import React from "react";
import { ToggleControl } from "common/components/Toggle";
import { useAppDispatch, useAppSelector } from "common/hooks/storeHooks";
import { UserActions } from "common/reducers/user.actions";
import { currentUser, userPreferences } from "common/selectors/user.selectors";
import { List } from "immutable";

export interface INotificationControlsProps {
  control_type: string;
  controls: List<{ key: string; label: string }>;
}

export const NotificationControls: React.FC<INotificationControlsProps> = ({ control_type, controls }) => {
  const path = ["preferences", "config", "notifications"];
  const dispatch = useAppDispatch();
  const user = useAppSelector(currentUser);

  const notificationsConfig = useAppSelector((state) =>
    userPreferences(state, { userId: user?.id, path: ["config", "notifications", control_type] }),
  );

  const handleToggleChange = (event: any, controlKey: string) => {
    const { checked } = event.target;
    if (checked) {
      dispatch(UserActions.concat({ path, name: control_type, value: List([controlKey]) }));
    } else {
      dispatch(UserActions.remove({ path, name: control_type, value: controlKey }));
    }
  };

  return (
    <>
      <div className="grid grid-cols-7">
        {controls.map((control) => {
          return (
            <div className="col-span-2 m-5" key={control.key}>
              <ToggleControl
                value={notificationsConfig.includes(control.key)}
                handleInput={(event) => handleToggleChange(event, control.key)}
                label={control.label}
                name={`${control.key}-${control_type}`}
                size="sm"
              />
            </div>
          );
        })}
      </div>
    </>
  );
};
